import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components';
import './Contributor.scss';

const Contributor = ({ avatar, name, job }) => (
  <div className={'contributor'}>
    <img
      src={avatar}
      alt={`Contributor Photo - ${name}`}
      className={'contributor__avatar'}
    />
    <Paragraph additionalClass={'contributor__name'}>{name}</Paragraph>
    <Paragraph additionalClass={'contributor__job'}>{job}</Paragraph>
  </div>
);

Contributor.propTypes = {
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  job: PropTypes.string.isRequired,
};

export default Contributor;
